import api from "./axios";

export const getMoneyOut = (params = {}) => api.get("/finances/money-out", { params });
export const getMoneyOutSummary = (params = {}) => api.get("/finances/money-out/summary", { params });
export const getExpenseCategories = () => api.get("/finances/expense-categories");
export const createExpense = (data) => api.post("/finances/expenses", data);
